const enumQuestionType = {
  Bool: 'Bool',
  Numeric: 'Numeric',
  Text: 'Text',
  Scale: 'Scale',
  MultiChoice: 'MultiChoice',
  Checklist: 'Checklist',
  TimeInput: 'TimeInput'
};

export default enumQuestionType;
